import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const bezierConfig = { p0: 0.68, p1: -0.1, p2: 0.32, p3: 1.1 };
const candleUrls = [
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_1.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_1.png`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_2.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_2.png`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_3.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_3.webp`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_4.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_4.png`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_5.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_5.png`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_6.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_6.webp`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_7.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_7.webp`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_8.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_8.webp`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_9.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_9.png`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/candle_10.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/candle_10.png`,
    },
];
const wandUrls = [
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/star_wand_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/star_wand_1.webp`,
    },
    {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/candles/star_wand_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/candles/star_wand_2.webp`,
    },
];
export const birthdayCandles = {
    version: 1,
    themeId: "birthday-candles",
    name: "Birthday Candles",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/birthday-candles.webp`,
    background: [
        {
            variant: "shimmer",
            images: [
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/background_1.jpg`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/background_1.jpg`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/background_2.jpg`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/birthday-candles/optimized/background_2.jpg`,
                },
            ],
        },
    ],
    scenes: [
        {
            type: "birthdayCandlesIntro",
            durationSeconds: 6.5,
            faceCollage: {
                variant: "hex-grid",
                borderShape: "circle",
                startAtSeconds: 1,
                faceCollageSceneDurationSeconds: 10,
            },
            candleUrls,
            wandUrls,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: { variant: "candles", candleUrls, wandUrls },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: { variant: "candles", candleUrls, wandUrls },
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
            sceneBackground: { variant: "candles", candleUrls, wandUrls },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#fff",
            fontFamily: "Satisfy",
            fontWeight: "light",
            fontSize: 96,
            leading: 1.1,
            tracking: 0,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "candles",
                startOffsetSeconds: 0.6,
                candleUrls,
            },
            betweenTransition: {
                variant: "slide-in-out",
                direction: "from-bottom",
                timing: {
                    variant: "bezier",
                    config: bezierConfig,
                    durationSeconds: 1.25,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Satisfy",
                fontWeight: "light",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Advent Pro",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.95,
            borderRadius: "1rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "slide-in-out",
            direction: "from-bottom",
            timing: {
                variant: "bezier",
                config: bezierConfig,
                durationSeconds: 1.25,
            },
        },
    },
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name",
            defaultValue: "",
            placeholder: "Sarah",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 90,
            },
        },
        {
            id: "age",
            type: "number",
            label: "Age",
            defaultValue: "",
            placeholder: "30",
            required: true,
            min: 1,
            max: 125,
            preview: {
                sceneIndex: 0,
                frameOffset: 90,
            },
        },
    ],
};
